import {
  SignedIn,
  SignedOut,
  SignInButton,
} from "@clerk/clerk-react";
import type { ReactNode } from "react";

interface AuthGateProps {
  children: ReactNode;
}

export function AuthGate({ children }: AuthGateProps) {
  return (
    <>
      <SignedOut>
        <div className="h-screen w-screen flex flex-col items-center justify-center gap-[var(--spacing-6)] bg-[var(--color-bg-canvas)] text-[var(--color-text-primary)]">
          <div className="flex flex-col items-center gap-[var(--spacing-2)]">
            <div className="h-[48px] w-[48px] rounded-[var(--radius-lg)] bg-gradient-to-br from-[var(--color-accent-400)] to-[var(--color-accent-600)] flex items-center justify-center mb-[var(--spacing-2)]">
              <svg width="24" height="24" viewBox="0 0 16 16" fill="none">
                <path d="M8 2v12M2 8h12" stroke="white" strokeWidth="2" strokeLinecap="round" />
              </svg>
            </div>
            <h1 className="text-[14px] font-semibold">AI Wave — GTM Tracker</h1>
            <p className="text-[14px] text-[var(--color-text-muted)]">Sign in to access the launch tracker</p>
          </div>
          <SignInButton mode="modal">
            <button className="px-[var(--spacing-6)] py-[var(--spacing-2)] bg-[var(--color-accent)] text-white rounded-[var(--radius-md)] text-[14px] font-medium hover:bg-[var(--color-accent-hover)] transition-colors duration-[var(--duration-fast)] cursor-pointer focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[var(--color-accent-focus)] focus-visible:ring-offset-2 focus-visible:ring-offset-[var(--color-bg-canvas)]">
              Sign In
            </button>
          </SignInButton>
        </div>
      </SignedOut>
      <SignedIn>
        {children}
      </SignedIn>
    </>
  );
}
